import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const DescriptionContainer = styled('div')`
  max-width: 280px;
`;

export const CopyBlock = styled('div')`
  color: ${({ theme }) => theme.color.white};
  ${({ theme }) => theme.typography.xSmall};
  text-align: left;
  padding: ${({ theme }) => theme.x1space}px;
  margin: 0;
`;

export const ScoreLabel = styled('span')`
  color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
  ${({ theme }) => theme.typography.xSmall};
  padding: 0 ${({ theme }) => theme.x1space}px;
`;

export const DescriptionBlock = styled(CopyBlock)`
  padding-bottom: ${({ theme }) => theme.x2spacePx}px;
`;

export const DescriptionHeading = styled('p')`
  margin: 0;
  ${({ theme }) => theme.typography.baseStrong}
`;

export const HeadingNumber = styled('span')`
  color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
  margin: 0;
  margin-right: ${({ theme }) => theme.x1spacePx / 3.33}px;
  padding-right: ${({ theme }) => theme.x1spacePx}px;
  position: relative;
  &::before {
    content: ' ';
    position: absolute;
    right: 0;
    top: 20%;
    width: 1px;
    height: 60%;
    background-color: ${({ theme }) => theme.color.white};
  }
`;

export const Container = styled('div')`
  position: absolute;
  top: 0;
  opacity: 0.3;
  padding: 11%; /* 😒 */
`;

export const SnowflakeSlice = styled('path')`
  cursor: pointer;
  fill: transparent;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  transition: fill 0.2s ease;
  ${media.lgUp`
    &:hover {
      fill: ${({ theme }) => theme.color.whiteRGBA(0.4)};
    }
  `}
  ${media.mdDown`
    &:focus {
      fill: ${({ theme }) => theme.color.whiteRGBA(0.4)};
    }
  `}
`;
